import { Injectable, OnDestroy, inject } from '@angular/core';
import {
  AlertButton,
  AlertController,
  AlertInput,
  LoadingOptions,
} from '@ionic/angular';
import { AlertModel } from '@models/alert.model';
import { OtpChannel } from '@models/custom-types.model';
import { Nazione } from '@models/indirizzo.model';
import { AlertService } from '@services/alert.service';
import {
  BehaviorSubject,
  Observable,
  Subject,
  concat,
  firstValueFrom,
  of,
  takeUntil,
  throwError,
} from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { QRCodeResponse } from 'src/app/shared/components/qr-code/qrcode/qrcode.interface';
import { IApiStandardResponse } from '../models/api/api.models';
import {
  IApiComuniSearchResponse,
  IComuneSearch,
  I_API_GET_Nazione,
} from '../models/indirizzo.model';
import {
  APIAssunzione,
  APICategoriaLavorativa,
  APIQualificaProfessionale,
  IAPICodiceAteco,
  IAPINaturaGiuridica,
  IAPIStatoCivile,
  IAPITipoDocumento,
  IAssunzione,
  ICategoriaLavorativa,
  ICategorieMerceologiche,
  ICodiceAteco,
  INaturaGiuridica,
  IQualificaProfessionale,
  IStatoCivile,
  ITipoDocumento,
  ITitoloDiStudio,
  User,
} from '../models/user.model';
import { ApiService } from './api/api.service';
import { ToastService } from './toast.service';
import { UserRepository } from './user.repository.service';
import { UserService } from './user.service';

@Injectable({
  providedIn: 'root',
})
export class AppService implements OnDestroy {
  private log_label = 'AppService';
  private alertOpt: AlertModel = new AlertModel();

  private userService = inject(UserService);
  private userRepository = inject(UserRepository);
  private alertController = inject(AlertController);
  private toastService = inject(ToastService);
  private alertService = inject(AlertService);
  private apiService = inject(ApiService);

  lista_nazioni$ = new BehaviorSubject<I_API_GET_Nazione[]>([]);
  titoli_di_studio$ = new BehaviorSubject<ITitoloDiStudio[]>([]);
  nature_giuridiche$ = new BehaviorSubject<INaturaGiuridica[]>([]);
  codici_ateco$ = new BehaviorSubject<ICodiceAteco[]>([]);
  categorie_merceologiche$ = new BehaviorSubject<ICategorieMerceologiche[]>([]);
  statoCivile$ = new BehaviorSubject<IStatoCivile[]>([]);
  tipi_documento$ = new BehaviorSubject<ITipoDocumento[]>([]);
  qualifica_professionale$ = new BehaviorSubject<IQualificaProfessionale[]>([]);
  assunzione$ = new BehaviorSubject<IAssunzione[]>([]);
  categoria_lavorativa$ = new BehaviorSubject<ICategoriaLavorativa[]>([]);

  private currentUser: User | null = null;
  private chiamate_alle_liste: boolean = false;

  public loadingOpt: LoadingOptions = {
    message: 'Caricamento...',
    spinner: 'circular',
    cssClass: 'custom-loading',
  };
  alert!: HTMLIonAlertElement;

  private destroy$ = new Subject<void>();

  constructor() {
    this.currentUser = this.userRepository.getUser();

    if (this.currentUser && !this.chiamate_alle_liste) {
      this.chiamate_alle_liste = true;
      concat(
        this.getNazioni().pipe(
          catchError((error) => {
            // Console.log(this.log_label, 'Errore chiamata getNazioni(): ' + JSON.stringify(error), 'err');
            return of(undefined);
          })
        ),
        // this.getTitoliDiStudio().pipe(
        //   catchError((error) => {
        //     // Console.log(this.log_label, 'Errore chiamata getTitoliDiStudio(): ' + JSON.stringify(error), 'err');
        //     return of(undefined);
        //   })
        // ),
        this.getNatureGiuridiche().pipe(
          catchError((error) => {
            // Console.log(this.log_label, 'Errore chiamata getNatureGiuridiche(): ' + JSON.stringify(error), 'err');
            return of(undefined);
          })
        ),
        // this.getCodiciAteco().pipe(
        //   catchError((error) => {
        //     // Console.log(this.log_label, 'Errore chiamata getCodiciAteco(): ' + JSON.stringify(error), 'err');
        //     return of(undefined);
        //   })
        // ),
        this.getCategoriaMerciologica().pipe(
          catchError((error) => {
            // Console.log(this.log_label, 'Errore chiamata getCategoriaMerciologica(): ' + JSON.stringify(error), 'err');
            return of(undefined);
          })
        ),
        this.getTipoDocumento().pipe(
          catchError((error) => {
            // Console.log(this.log_label, 'Errore chiamata getTipoDocumento(): ' + JSON.stringify(error), 'err');
            return of(undefined);
          })
        ),
        // this.getStatoCivile().pipe(
        //   catchError((error) => {
        //     // Console.log(this.log_label, 'Errore chiamata getStatoCivile(): ' + JSON.stringify(error), 'err');
        //     return of(undefined);
        //   })
        // ),
        // this.getQualificaProfessionale().pipe(
        //   catchError((error) => {
        //     // Console.log(this.log_label, 'Errore chiamata getQualificaProfessionale(): ' + JSON.stringify(error), 'err');
        //     return of(undefined);
        //   })
        // ),
        // this.getAssunzione().pipe(
        //   catchError((error) => {
        //     // Console.log(this.log_label, 'Errore chiamata getAssunzione(): ' + JSON.stringify(error), 'err');
        //     return of(undefined);
        //   })
        // ),
        // this.getCategoriaLavorativa().pipe(
        //   catchError((error) => {
        //     // Console.log(this.log_label, 'Errore chiamata getCategoriaLavorativa(): ' + JSON.stringify(error), 'err');
        //     return of(undefined);
        //   })
        // )
      )
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: () => {
            // Console.log(
            //   this.log_label,
            //   'Recuperate liste (o gestiti errori) Nazioni, Titoli di studio, Nature giuridiche, Codici Ateco, Categorie merceologiche, Tipi documento, Stato civile, Qualifica professionale, Assunzione, Categoria lavorativa.'
            // );
          },
          error: (error) => {
            this.chiamate_alle_liste = false;
            // Console.log(this.log_label, 'Errore catena liste: ' + JSON.stringify(error), 'err');
          },
        });
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  /* ----------------------------------- UTILITY -------------------------------------------- */

  buildQrcode(link: string): Observable<string> {
    return this.apiService.get<QRCodeResponse>(link).pipe(
      map((response: QRCodeResponse) => response.data.qrcode_link),
      catchError((error) => {
        // Console.log(this.log_label, 'Errore generazione QRCode: ' + JSON.stringify(error), 'err');
        return throwError(() => error);
      })
    );

    // return this.apiService.post<QRCodeResponse, { link: string }>('qrcode', { link }).pipe(
    //   map((response: QRCodeResponse) => response.data.qrcode_link)
    // );
  }

  /* QUESTO METODO SI OCCUPA DELLA RICHIESTA DELL'OTP */
  otpRequest(type: OtpChannel): Observable<IApiStandardResponse<unknown>> {
    const api_type = { cellulare: 'sms', email: 'email' };
    return this.apiService.get<IApiStandardResponse<unknown>>(`richiesta-otp/${api_type[type]}`);
  }

  /* QUESTO METODO SI OCCUPA DELLA VALIDAZIONE DELL'OTP */
  otpValidate(code: number): Observable<IApiStandardResponse<unknown>> {
    return this.apiService.get<IApiStandardResponse<unknown>>(`valida-otp/${code}`);
  }

  /* QUESTO METODO SI OCCUPA DELLA GESTIONE DELL'OTP */
  checkOtp(type: OtpChannel): Observable<boolean> {
    const subject: Subject<boolean> = new Subject();

    let buttons: AlertButton[] = [
      {
        text: 'ok',
        role: '',
        handler: (res: { codice: number }) => {
          if (res.codice > 0) {
            this.otpValidate(res.codice).subscribe({
              next: (res_otpValidate: IApiStandardResponse<unknown>) => {
                subject.next(true);
                subject.complete();
              },
              error: (err_otpValidate) => {
                subject.next(false);
                subject.error(err_otpValidate);
                subject.complete();
              },
            });
          } else {
            subject.error({ message: 'Codice non valido' });
            subject.complete();
          }
        },
      },
      { text: 'Annulla', role: 'cancel', handler: (res) => false },
    ];

    let inputs: AlertInput[] = [
      { name: 'codice', type: 'number', placeholder: 'Inserisci Codice OTP' },
    ];

    this.otpRequest(type).subscribe({
      next: async (res: { message: string }) => {
        const alert = await this.alertController.create({
          header: 'Conferma OTP ' + type,
          message: 'Inserire il codice OTP ricevuto',
          inputs: inputs,
          buttons: buttons,
          backdropDismiss: false,
        });
        await alert.present();
      },
      error: (error) => {
        throw error;
      },
    });

    return subject.asObservable();
  }

  /* ------------------------------------ INFO NAZIONE -------------------------------------- */

  getNazioni(): Observable<IApiStandardResponse<Nazione[]>> {
    return this.apiService
      .get<IApiStandardResponse<Nazione[]>>('geo/nazioni')
      .pipe(
        map((response: IApiStandardResponse<Nazione[]>) => {
          this.lista_nazioni$.next(response.data);
          return response;
        })
      );
  }

  getTitoliDiStudio(): Observable<IApiStandardResponse<ITitoloDiStudio[]>> {
    return this.apiService
      .get<IApiStandardResponse<ITitoloDiStudio[]>>('tipo/titolo-studio')
      .pipe(
        map((response) => {
          this.titoli_di_studio$.next(response.data);
          return response;
        })
      );
  }

  getNatureGiuridiche(): Observable<IAPINaturaGiuridica> {
    return this.apiService
    .get<IAPINaturaGiuridica>('tipo/natura-giuridica')
    .pipe(
      map((response: IAPINaturaGiuridica) => {
        const sortedData = response.data.sort((a, b) => 
          a.descrizione.localeCompare(b.descrizione)
        );
        this.nature_giuridiche$.next(sortedData);
        return response;
      })
    );
  }

  getStatoCivile(): Observable<IAPIStatoCivile> {
    return this.apiService.get<IAPIStatoCivile>('tipo/stato-civile').pipe(
      map((response: IAPIStatoCivile) => {
        this.statoCivile$.next(response.data);
        return response;
      })
    );
  }

  getCodiciAteco(): Observable<IAPICodiceAteco> {
    return this.apiService.get<IAPICodiceAteco>('tipo/codice-ateco').pipe(
      map((response: IAPICodiceAteco) => {
        this.codici_ateco$.next(response.data);
        return response;
      })
    );
  }

  getCategoriaMerciologica(): Observable<
    IApiStandardResponse<ICategorieMerceologiche[]>
  > {
    return this.apiService
      .get<IApiStandardResponse<ICategorieMerceologiche[]>>(
        'tipo/categoria-merceologica'
      )
      .pipe(
        map((response) => {
          this.categorie_merceologiche$.next(response.data);
          return response;
        })
      );
  }

  getTipoDocumento(): Observable<IAPITipoDocumento> {
    return this.apiService.get<IAPITipoDocumento>('tipo/documento').pipe(
      map((response: IAPITipoDocumento) => {
        this.tipi_documento$.next(response.data);
        return response;
      })
    );
  }

  getQualificaProfessionale(): Observable<APIQualificaProfessionale> {
    return this.apiService.get<APIQualificaProfessionale>('tipo/lavoro').pipe(
      map((response: APIQualificaProfessionale) => {
        this.qualifica_professionale$.next(response.data);
        return response;
      })
    );
  }

  getAssunzione(): Observable<APIAssunzione> {
    return this.apiService.get<APIAssunzione>('tipo/assunzione').pipe(
      map((response: APIAssunzione) => {
        this.assunzione$.next(response.data);
        return response;
      })
    );
  }

  getCategoriaLavorativa(): Observable<APICategoriaLavorativa> {
    return this.apiService
      .get<APICategoriaLavorativa>('tipo/categoria-lavorativa')
      .pipe(
        map((response: APICategoriaLavorativa) => {
          this.categoria_lavorativa$.next(response.data);
          return response;
        })
      );
  }

  getComuniByDesc(comune: string): Observable<IComuneSearch[]> {
    return this.apiService
      .get<IApiComuniSearchResponse>(`geo/comuni/search/${comune}`)
      .pipe(
        map((response: IApiComuniSearchResponse) => response.data),
        catchError((error: any) => {
          // Console.log(this.log_label, 'Errore chiamata getComuniByDesc(): ' + JSON.stringify(error), 'err');
          this.toastService.presentaToastErrore(
            'Errore nella ricerca comuni',
            this.log_label
          );
          return throwError(() => error);
        })
      );
  }

  getProvince(): Observable<any> {
    return this.apiService.get<any>('geo/province');
  }

  getComunebyProv(sig_prov: string): Observable<any> {
    return this.apiService.get<any>(`geo/province/${sig_prov}/comuni`);
  }

  getComune(cod_com: string): Observable<any> {
    return this.apiService.get<any>(`geo/comuni/${cod_com}`);
  }

  async controlloPartitaIva(partitaIva: string) {
    try {
      return await firstValueFrom(
        this.apiService.get<any>(
          `anagrafica/ricerca/persona-giuridica/${partitaIva}`
        )
      );
    } catch (error: any) {
      // Console.log(this.log_label, 'getSedeLegale() ' + JSON.stringify(error), 'err');
      this.toastService.presentaToastErrore(error.message, this.log_label);
      return false;
    }
  }
}
